const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const withVaultDispatch = require("../core/hoc/withVaultDispatch");

const AT = require("../core/vault/ActionTypes");

const SelectCSV = require("./SelectCSV");
const InfoIcon = require("../office/InfoIcon");
const Dropdown = require("./SchoolDropdown");
const LoadableButton = require("../office/LoadableButton");

const styles = require("./styles/RosteringCSVSelect.css");

const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "RosteringCSVSelect",

		propTypes: {
			roster: PT.object.isRequired,
			currentYear: PT.number.isRequired,
			selectedYear: PT.string.isRequired,
			onContinue: PT.func.isRequired,
			loadStateToStatus: PT.object.isRequired,
			schoolState: PT.object.isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getInitialState() {
			return {
				yearFilter: "currentYear",
			};
		},

		componentDidUpdate(prevProps, prevState) {
			if (prevState.yearFilter !== this.state.yearFilter) {
				this.props.dispatch({
					type: AT.ROSTERING_VALIDATE_CSVS_RESET,
				});
			}
		},

		// Whenever a file is selected, we will still dispatch that
		// a file was selected, but we will only have the
		// validation reset if the file chosen was either one of
		// a different name, or the same file that was more recently
		// modified than the version previously selected
		onRosterSelected: function(roster, file, contents) {
			this.props.dispatch({
				type: AT.ROSTERING_SELECT_CSV,
				roster: roster + "Roster",
				file,
				contents,
			});
		},

		getValidateButtonMessage: function() {
			const {roster} = this.props;
			const bothFilesValid = this.areRostersValidated();
			const bothFilesSelected =
				this.isStaffRosterSelected() && this.isStudentRosterSelected();

			let message = bothFilesSelected
				? "Click the button below to check for errors in your rosters."
				: "";
			if (roster.validation.load === "pending") {
				message = "It may take a few minutes to validate your rosters";
			} else if (roster.validation.load === "error") {
				message = null;
			} else if (roster.validation.load === "done") {
				if (bothFilesValid && bothFilesSelected) {
					message =
						"Success! Your roster contains no errors. Click continue to review the updates before processing them.";
				} else {
					message = "";
				}
			}
			return <div className={styles.validationText}>{message}</div>;
		},

		getInfoIconText: function() {
			const {currentYear} = this.props;
			return (
				<div className={styles.infoIconText}>
					<p className={styles.infoIconTextPiece}>
						{`If you are updating your rosters for the current academic year, choose ${currentYear -
							1}-${currentYear}.`}
					</p>
					<p className={styles.infoIconTextPiece}>
						{`If you are planning ahead and creating your rosters for the next academic year, choose ${currentYear}-${currentYear +
							1}.`}
					</p>
				</div>
			);
		},

		makeYearSelect: function() {
			const {currentYear} = this.props;
			return (
				<Dropdown
					className={styles.years}
					options={{
						currentYear: `${currentYear - 1}-${currentYear}`,
						nextYear: `${currentYear}-${currentYear + 1}`,
					}}
					initialValue={this.props.selectedYear}
					updateSelection={this.updateYearFilter}
					style={"rectangle"}
				/>
			);
		},

		updateYearFilter: function(val) {
			this.setState({
				yearFilter: val,
			});
			this.props.dispatch({
				type: AT.ROSTERING_UPLOAD_SET_YEAR,
				year: val,
			});
		},

		validateCSVs: function() {
			this.props.dispatch({
				type: AT.ROSTERING_VALIDATE_CSVS_REQUEST,
				staffRoster: _.get(this.props.roster, [
					"model",
					"staffRoster",
					"contents",
				]),
				studentRoster: _.get(this.props.roster, [
					"model",
					"studentRoster",
					"contents",
				]),
				year:
					this.props.selectedYear === "currentYear"
						? this.props.currentYear
						: this.props.currentYear + 1,
				purchaseID: _.get(this.props.schoolState, [
					"accounts",
					"purchase",
					"id",
				]),
			});
		},

		goToNextStep: function() {
			const {onContinue} = this.props;
			onContinue();
		},

		isStaffRosterSelected: function() {
			return (
				_.get(this.props.roster, ["model", "staffRoster", "fileInfo"], null) !==
				null
			);
		},

		isStudentRosterSelected: function() {
			return (
				_.get(
					this.props.roster,
					["model", "studentRoster", "fileInfo"],
					null
				) !== null
			);
		},

		areRostersValid: function() {
			return (
				_.get(this.props.roster, ["validation", "rosterErrors"], []).length ===
				0
			);
		},

		areRostersValidated: function() {
			const validationStatus = _.get(
				this.props.roster,
				["validation", "load"],
				"none"
			);
			const rosterErrors = _.get(
				this.props.roster,
				["validation", "rosterErrors"],
				[]
			);
			return validationStatus === "done" && rosterErrors.length === 0;
		},

		renderValidateButton: function() {
			const bothFilesSelected =
				this.isStaffRosterSelected() && this.isStudentRosterSelected();
			const bothFilesValidated = this.areRostersValidated();
			let buttonText = "Validate";

			if (bothFilesValidated) {
				buttonText = "Continue";
			}
			let isDisabled = false;
			if (buttonText === "Validate") {
				if (!bothFilesSelected) {
					isDisabled = true;
				} else if (
					bothFilesSelected &&
					_.get(this.props.roster, ["validation", "rosterErrors"], []).length
				) {
					isDisabled = true;
				}
			}
			const rosterLoadStatus = _.get(this.props.roster, ["validation", "load"]);
			const button = (
				<LoadableButton
					buttonText={buttonText}
					status={this.props.loadStateToStatus[rosterLoadStatus]}
					className={isDisabled ? styles.buttonDisabled : styles.button}
					onClick={
						buttonText === "Continue" ? this.goToNextStep : this.validateCSVs
					}
					isDisabled={isDisabled}
				/>
			);

			return button;
		},

		renderFileError: function(error, count) {
			return (
				<li key={`error-${count}`} className={styles.fileError}>
					{`${error}`}
				</li>
			);
		},

		renderErrors: function(errors) {
			const errorHeader = (
				<div className={styles.errorsHeader}>
					{
						"The rosters you submitted contain the following errors. Please fix and reupload the files."
					}
				</div>
			);

			const rosterErrors = _.get(this.props.roster, [
				"validation",
				"rosterErrors",
			]);

			const allErrors = [];
			_.each(rosterErrors, (err, idx) => {
				allErrors.push(this.renderFileError(err, idx));
			});

			return allErrors.length ? (
				<div className={styles.validationErrors}>
					{errorHeader}
					<ul className={styles.errorsList}>{allErrors}</ul>
				</div>
			) : null;
		},

		renderCSVSelect: function(which, uploadText) {
			const rosterName = which + "Roster";
			const isValid = _.get(this.props.roster, ["validation", "valid"], true);
			const onSelected = (file, contents) =>
				this.onRosterSelected(which, file, contents);

			const file = _.get(this.props.roster, ["model", rosterName, "fileInfo"]);

			return (
				<div className={styles.uploadRoster}>
					<div className={styles.fileInput}>
						<div className={styles.uploadTextLeft}>{uploadText}</div>
						<SelectCSV
							onSelected={onSelected}
							for={which}
							fileInfo={file}
							outlineClass={isValid ? null : styles.redOutline}
							hasError={!isValid}
						/>
					</div>
				</div>
			);
		},

		render: function() {
			return (
				<div className={styles.main}>
					<div className={styles.yearSelect}>
						<div className={styles.infoIcon}>
							<InfoIcon
								title={"Year"}
								text={this.getInfoIconText()}
								isModal={true}
								className={styles.info}
							/>
						</div>
						<div className={styles.infoIconLabel}>Year:</div>
						<div className={styles.yearSelectDropdown}>
							{this.makeYearSelect()}
						</div>
					</div>
					<div className={styles.upload}>
						{this.renderCSVSelect("staff", "Staff Roster:")}
						{this.renderCSVSelect("student", "Student Roster:")}
					</div>
					<div className={styles.validateMessage}>
						{this.getValidateButtonMessage()}
					</div>
					{this.renderValidateButton()}
					{this.renderErrors()}
				</div>
			);
		},
	})
);
